import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AbsenceRequestDirective } from '@app/+modals/employee/absence-request/absence-request.directive';
import { StatSummaryBlockComponent } from '@app/shared/summary/stat-summary-block.component';
import { StatSummaryFooterItemComponent } from '@app/shared/summary/stat-summary-footer-item.component';
import { StatSummaryFooterComponent } from '@app/shared/summary/stat-summary-footer.component';
import { StatSummaryTitleDirective } from '@app/shared/summary/stat-summary-title.directive';
import { StatSummaryValueComponent } from '@app/shared/summary/stat-summary-value.component';
import { StatSummaryComponent } from '@app/shared/summary/stat-summary.component';
import { AnchorButtonComponent, ButtonComponent, ButtonGroupComponent, IconButtonComponent } from '@sb/ui/button';
import { CardComponent } from '@sb/ui/card';
import { CheckboxComponent } from '@sb/ui/checkbox';
import { SbDateRangePickerComponent } from '@sb/ui/date-picker';
import { SbDialogModule } from '@sb/ui/dialog';
import { DividerDirective } from '@sb/ui/divider';
import { DropdownModule } from '@sb/ui/dropdown';
import { EmptyStateComponent, LoadingStateComponent } from '@sb/ui/feedback';
import {
  GridScrollFollowerDirective,
  GridScrollRowDirective,
  GridScrollViewportDirective,
  GridStickyColumnDirective,
} from '@sb/ui/grid-scroll';
import { IconComponent } from '@sb/ui/icon';
import { InputModule } from '@sb/ui/input';
import { ResizeObserverDirective } from '@sb/ui/resize-observer';
import { StatusButtonComponent, StatusIconComponent } from '@sb/ui/status';
import {
  TableCellPrimitiveDirective,
  TableContainerDirective,
  TableDirective,
  TableHeaderCellDirective,
  TableRowDirective,
  TableStickyColumnDirective,
} from '@sb/ui/table';

import { KnowledgeBaseArticleLinkModule } from '../../pipes/knowledge-base-article-link.module';
import { SharedModule } from '../../shared/shared.module';
import { AbsenceCalendarComponent } from '../+employees/shared/employee-absence-overview/absence-calendar/absence-calendar.component';
import { AbsenceListSectionComponent } from '../+employees/shared/employee-absence-overview/absence-list/absence-list-section.component';
import { AbsenceTypeDistributionComponent } from '../+employees/shared/employee-absence-overview/absence-type-distribution/absence-type-distribution.component';
import { EmployeeAbsenceOverviewComponent } from '../+employees/shared/employee-absence-overview/employee-absence-overview.component';
import { TimeOffBalancesComponent } from '../+employees/shared/employee-absence-overview/time-off-balances/time-off-balances.component';
import { EmployeeHoursOverviewComponent } from '../+employees/shared/employee-hours-overview/employee-hours-overview.component';
import { EmployeePlusminOverviewComponent } from '../+employees/shared/employee-plusmin-overview/employee-plusmin-overview.component';
import { AbsenceItemComponent } from '../+schedule/employee/schedule-employee-n-period/schedule-items/absence/absence-item.component';
import { TimesheetDaySharedModule } from '../+timesheet/shared/day/timesheet-day-shared.module';
import { TimesheetSidebarComponent } from '../+timesheet/shared/timesheet/timesheet-sidebar/timesheet-sidebar.component';
import { PersonalScheduleComponent } from '../dashboard/my-schedule/personal-schedule.component';
import { SidePanelHeaderComponent } from './app-side-panel/side-panel-header.component';
import { DepartmentsDropdownComponent } from './departments-dropdown/departments-dropdown.component';
import { ActionConfirmDirective } from './directives/action-confirm.directive';
import { FiltersToggleComponent } from './filters-toggle/filters-toggle.component';
import { SidebarHeaderComponent } from './sidebar/sidebar-header.component';
import { SplitButtonQuotaDirective } from './split-button-quota.directive';

const imports = [
  SharedModule,
  RouterModule,
  TimesheetDaySharedModule,
  IconComponent,
  ActionConfirmDirective,
  StatusButtonComponent,
  StatusIconComponent,
  SplitButtonQuotaDirective,
  InputModule,
  IconButtonComponent,
  AbsenceTypeDistributionComponent,
  AbsenceListSectionComponent,
  ButtonGroupComponent,
  AbsenceCalendarComponent,
  ButtonComponent,
  AnchorButtonComponent,
  TimeOffBalancesComponent,
  SbDialogModule,
  SidebarHeaderComponent,
  SidePanelHeaderComponent,
  DepartmentsDropdownComponent,
  FiltersToggleComponent,
  DropdownModule,
  AsyncPipe,
  DividerDirective,
  CardComponent,
  EmptyStateComponent,
  LoadingStateComponent,
  StatSummaryComponent,
  StatSummaryBlockComponent,
  StatSummaryValueComponent,
  StatSummaryTitleDirective,
  StatSummaryFooterComponent,
  StatSummaryFooterItemComponent,
  TableContainerDirective,
  TableDirective,
  TableRowDirective,
  TableCellPrimitiveDirective,
  TableHeaderCellDirective,
  TableStickyColumnDirective,
];

const declarations = [EmployeePlusminOverviewComponent, EmployeeHoursOverviewComponent, TimesheetSidebarComponent];

const standalone = [
  AbsenceRequestDirective,
  AbsenceItemComponent,
  EmployeeAbsenceOverviewComponent,
  PersonalScheduleComponent,
  ResizeObserverDirective,
  GridScrollFollowerDirective,
  GridScrollRowDirective,
  GridScrollViewportDirective,
  GridStickyColumnDirective,
];

@NgModule({
  imports: [...imports, ...standalone, KnowledgeBaseArticleLinkModule, SbDateRangePickerComponent, CheckboxComponent],
  declarations: declarations,
  exports: [...imports, ...declarations, ...standalone],
})
export class SharedAuthModule {}
